/*
|--------------------------------------------------------------------------
| API Call Filters
|--------------------------------------------------------------------------
|
| The constants below represent the filters that can be used to filter
| API requests to retrieve call models from the database.
|
*/
export const CALLS_FILTER = 'calls_only'
export const COMPLETE_FILTER = 'complete'
export const FULL_VISIBILITY_FILTER = 'full_visibility_only'
export const INCOMPLETE_FILTER = 'incomplete'
export const NOTED_FILTER = 'noted'
export const PAGING_FILTER = 'paging_only'
export const DISMISS_FILTER = 'dismiss'

/**
 * The available call service API query filters.
 *
 * @type {Array}
 */
export const filters = [
	COMPLETE_FILTER,
	FULL_VISIBILITY_FILTER,
	INCOMPLETE_FILTER,
	NOTED_FILTER,
	PAGING_FILTER,
	DISMISS_FILTER,
]

/*
|--------------------------------------------------------------------------
| API Call Statuses
|--------------------------------------------------------------------------
|
| The constants below represent the statuses that an indididual call model
| can be assigned. These statuses only reference the actual pyhsical phone
| call status from Twilio.
|
*/
export const ARCHIVED_STATUS = { name: 'archived', label: 'Archived' }
export const COMPLETE_STATUS = { name: 'complete', label: 'Complete' }
export const DISMISS_STATUS = { name: 'dismiss', label: 'Dismiss' }
export const IN_PROGRESS_STATUS = { name: 'in-progress', label: 'In Progress' }
export const MISSED_STATUS = { name: 'missed', label: 'Missed' }
export const NEW_STATUS = { name: 'new', label: 'New' }
export const NOTIFICATIONS_SENT_STATUS = {
	name: 'notifications-sent',
	label: 'Notifications Sent',
}
export const RESPONDED_STATUS = { name: 'responded', label: 'Responded' }

/**
 * The available call status API query scope values.
 *
 * @type {Array}
 */
export const statuses = [
	ARCHIVED_STATUS,
	COMPLETE_STATUS,
	DISMISS_STATUS,
	IN_PROGRESS_STATUS,
	MISSED_STATUS,
	NEW_STATUS,
	NOTIFICATIONS_SENT_STATUS,
	RESPONDED_STATUS,
]

export const DEFAULT_VAL = 'N/A'
export const MULTIPLE_CAPITALIZED = 'Multiple'
export const MULTIPLE_LOWERCASE = 'multiple'
export const DEFAULT_PATIENT_DETAIL_SEQUENCE = [
	{
		internal_name: 'first_name',
		display_always: true,
		display_name: 'First Name',
		group: 1,
	},
	{
		internal_name: 'date_of_birth',
		display_always: true,
		display_name: 'Date Of Birth',
		group: 1,
	},
	{
		internal_name: 'callback_phone',
		display_name: 'Callback Phone',
		display_always: true,
		group: 2,
	},
	{
		internal_name: 'pharmacy_phone',
		display_name: 'Pharmacy Phone',
		display_always: true,
		group: 2,
	},
	{
		internal_name: 'provider',
		display_name: 'Provider',
		display_always: true,
		group: 2,
	},
]
export const DEFAULT_PATIENT_DETAIL_SEQUENCE_EMR = [
	{
		internal_name: 'first_name',
		display_name: 'First Name',
		value: null,
		display_always: true,
		group: 1,
	},
	{
		internal_name: 'middle_name',
		display_name: 'Middle Name',
		value: null,
		display_always: true,
		group: 1,
	},
	{
		internal_name: 'last_name',
		display_name: 'Last Name',
		value: null,
		display_always: true,
		group: 1,
	},
	{
		internal_name: 'date_of_birth',
		display_name: 'Date Of Birth',
		value: null,
		display_always: true,
		group: 1,
	},
	{
		internal_name: 'gender',
		display_name: 'Gender',
		value: null,
		display_always: true,
		group: 1,
	},
	{
		internal_name: 'callback_phone',
		display_name: 'Callback Phone',
		value: null,
		display_always: true,
		group: 2,
	},
	{
		internal_name: 'pharmacy_phone',
		display_name: 'Pharmacy Phone',
		value: null,
		display_always: true,
		group: 2,
	},
	{
		internal_name: 'provider',
		display_name: 'Provider',
		value: null,
		display_always: true,
		group: 2,
	},
]

export const SOURCE_OF_CALL = {
	CALL: 'call',
	PAGE: 'page',
	WMA: 'wma',
}

export const SUMMARY_OF_CALL = {
	CALL_INITIATED: 'call initiated',
	PAGE_MESSAGE_RECEIVED: 'page message received',
	WEB_MESSAGE_RECEIVED: 'web message received',
}
